export default __webpack_public_path__ + "static/media/1085-00.9bbcd9bf.jpg";